import type { IWorkJourneyReplacementCandidate } from '@src/models/interfaces/workJourneyManagement.interface';

import type { PlanMonthlyJourneyUnderMinImpact } from '../types';

export type EvaluatePlanMemberMoveImpactParams = {
  candidate: IWorkJourneyReplacementCandidate;
  previousAssignedMembers: number;
  previousRequiredMembers: number;
};

/**
 * When moving a user out of their current journey into the planned one,
 * warn if the previous journey would fall below its required minimum.
 */
export const evaluatePlanMemberMoveImpact = (
  params: EvaluatePlanMemberMoveImpactParams,
): PlanMonthlyJourneyUnderMinImpact | null => {
  const { candidate, previousAssignedMembers, previousRequiredMembers } = params;
  const previous = candidate.currentWorkJourney;
  if (!previous?.workJourneyConfigId) return null;

  const remaining = Math.max(0, previousAssignedMembers - 1);
  const required = Math.max(0, previousRequiredMembers);
  if (remaining >= required) return null;

  return {
    userDisplayName: candidate.displayName || candidate.email || candidate.id,
    journeyName: previous.workJourneyConfigName || previous.workJourneyConfigId,
    remainingMembers: remaining,
    requiredMembers: required,
    candidate,
  };
};
